export default __webpack_public_path__ + "static/media/document-logo-4.d0eeaf6b.svg";